SWR.Social.prototype._getSpotifyParams = function _getSpotifyParams() {
  var self = this;
  var data = {};

  // Spotify
  data.endpoint = 'https://embed.spotify.com/oembed';
  data.params = {
    // nicht offiziell
    'hidecaption': false,
    'omitscript': false
  };
  data.dataType = 'json';

  return data;
};

SWR.Social.prototype._updateSpotify = function _updateSpotify() {
  var self = this;
  self.$preview.hide();
  self.$content.show();
  self.$footer.show();

  self.$element.attr({
    'aria-busy': 'false'
  });
  self.$element.removeClass('embed-loading').addClass('embed-loaded');
  self._processing = false;
  self._processed = true;
};

SWR.Social.prototype._spotifyAlternative = function _spotifyAlternative() {
  var self = this;

  try {
    console.log(self.url.match(/(https?:\/\/open.spotify.com\/(track|user|artist|album|playlist)\/[a-zA-Z0-9]+(\/playlist\/[a-zA-Z0-9]+|)|spotify:(track|user|artist|album):[a-zA-Z0-9]+(:playlist:[a-zA-Z0-9]+|))/));
    var data = self.url.match(/(https?:\/\/open.spotify.com\/(track|user|artist|album|playlist)\/[a-zA-Z0-9]+(\/playlist\/[a-zA-Z0-9]+|)|spotify:(track|user|artist|album):[a-zA-Z0-9]+(:playlist:[a-zA-Z0-9]+|))/);
    var id = data[0].split('/').pop();
    var type = '';
    var height = '';

    for (var i = 0; i < data.length; i++) {
      var tmp = data[i];
      if (tmp === 'track' || tmp === 'user' || tmp === 'artist' || tmp === 'album' || tmp === 'playlist') {
        type = tmp;

        if (type === 'album' || type === 'playlist') {
          height = '; height: 380px';
        }
        break;
      }
    }

    if (type === '') {
      self._failed(self.config.embedCookie, self.url);
      return;
    }

    var html = COMMON.Utils.template('<iframe class="embed-responsive-item spotify-embed" src="{url}" allowtransparency="true" allow="encrypted-media" style="border: 0{height}"></iframe>', {
      'url': 'https://open.spotify.com/embed/' + type + '/' + id,
      'height': height
    });
    self._done(html);
  } catch (e) {
    self._failed(self.config.embedCookie, self.url);
  }
};
